import React from "react";
import { Component } from "react";
import { InputField } from "../../../common/custom-form/input-filter-component";
import { SelectField } from "../../../common/custom-form/select-filter.component";
import { Button } from "react-bootstrap";
import { DetailsDataTable } from "./details-table/details-table.component";
import { TextArea } from "../../../common/custom-form/custom-textarea.component";
export class AddSim extends Component {
    constructor(props) {
        super(props);
        this.state={
            filterSelected:"",
            installDate:"",
            showTable:false,
        }
    }
    ShowTable() {
        this.setState({showTable:!this.showTable})
        this.props.showDetails(true)
    }
    render(){
        return(
            <div className={`add-sim-container detail-page-container details-4-col-container`}>
                <SelectField label="SIM TYPE"  options={this.props.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>  
                <SelectField label="SIM RANK"  options={this.props.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>  
                <InputField label="SERIAL NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <InputField label="PIN NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <InputField label="PRODUCT NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <InputField label="SIM" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} /> 
                <InputField label="PUK 1" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <InputField label="PUK 2" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <TextArea label="ADDITIONAL INFORMATION" customClass="additional-textarea-info" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}/>                
                <div className="add-button-container ">
                    <Button>Cancel</Button>
                    <Button onClick={this.ShowTable.bind(this)}>Add</Button>
                </div>
            </div>
        )
    }
}